exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".scroll-to-top[data-v-2ca52aca] {\n  position: fixed;\n  bottom: 30px;\n  right: 30px;\n}\n.list-menu[data-v-2ca52aca] {\n  margin-bottom: 10px;\n}\n", ""]);

// exports
